export interface ISuspiciousLogsSent {
    version: string;
    data: string[];
}

export enum SuspiciousLogsSentActionTypes {
    SET_SUSPICIOUS_LOGS_SENT = "SET_SUSPICIOUS_LOGS_SENT",
    CLEAR_SUSPICIOUS_LOGS_SENT = "CLEAR_SUSPICIOUS_LOGS_SENT"
}